export default __webpack_public_path__ + "static/img-workshop-2019-ed54e0e9271b2a848ddb6425941b8763.png";